import axios from "../../service";
import { AddressService } from "../resources";

export const state = {
  addressList: {},
  configPickup: {},
  pickupOrderAddress: {}
};

export const mutations = {
  INIT_ADDR_LIST(state, newValue) {
    state.addressList = newValue;
  },
  UPDATE_ADDR(state, newValue) {
    state.addressList.address.push(newValue);
    state.addressList.total = state.addressList.total + 1;
  },
  EDIT_ADDR(state, newValue) {
    let index = state.addressList.address.findIndex(
      (o) => o.id === newValue.id
    );
    Object.assign(state.addressList.address[index], newValue);
  },
  DELETE_ADDR(state, newValue) {
    let resp = state.addressList.address.filter(
      (o) => o.id !== newValue.pickupId
    );
    state.addressList.address = resp;
    state.addressList.totral = state.addressList.total - 1;
  },
  INIT_PICKUP_CONFIG_LIST(state, newValue) {
    state.configPickup = newValue;
  },
  INIT_ADDR_ORDER_PICKUP_LIST(state, newValue) {
    state.pickupOrderAddress = newValue;
  },
  UPDATE_ADDR_ORDER_PICKUP_LIST(state, newValue) {
    state.pickupOrderAddress = newValue;
  }
};

export const getters = {
  isAddressList(state) {
    if (typeof state.addressList.address !== "undefined") {
      let addr = state.addressList.address.map((o) => {
        return {
          id: o.id,
          create_dt: o.create_dt,
          pickup_point_name: o.pickup_point_name,
          responser_name: o.responser_name,
          responser_tel: o.responser_tel,
          address: `${o.pickup_point_addr} ${o.pickup_point_district} ${o.pickup_point_city} ${o.pickup_point_province} ${o.pickup_point_postal_code}`,
          address_raw: {
            addr: o.pickup_point_addr,
            district: o.pickup_point_district,
            provine: o.pickup_point_province,
            zipcode: o.pickup_point_postal_code,
            city: o.pickup_point_city
          }
        };
      });
      return {
        address: addr,
        total: state.addressList.total
      };
    }
    return {
      address: [],
      total: 0
    };
  },

  getAddr: (state) => (id) => {
    return state.addressList.address.find((o) => o.id === id);
  },

  getPickupConfig(state) {
    return state.configPickup[0];
  },
  isOrderAddressPickup(state) {
    if (typeof state.pickupOrderAddress.addr !== "undefined") {
      let addr = state.pickupOrderAddress.addr.map((o) => {
        return {
          id: o.id,
          create_dt: o.create_dt,
          pickup_point_name: o.pickup_point_name,
          responser_name: o.pickup_responser_name,
          responser_tel: o.pickup_responser_tel,
          address: `${o.pickup_address} ${o.pickup_district} ${o.pickup_city} ${o.pickup_province} ${o.pickup_zip_code}`,
          address_raw: {
            addr: o.pickup_address,
            district: o.pickup_district,
            province: o.pickup_province,
            zipcode: o.pickup_zip_code,
            city: o.pickup_city
          },
          pickup_point_id: o.pickup_point_id
        };
      });
      return {
        address: addr,
        total: state.pickupOrderAddress.total
      };
    }
    return {
      address: [],
      total: 0
    };
  }
};

export const actions = {
  // async fetchAddressList({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/center/pickup", {
  //             params: { ...data },
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("INIT_ADDR_LIST", resp.data);
  //         return { status: true };
  //     } catch (error) {
  //         return { status: false, err: error };
  //     }
  // },

  // async addNewAddress({ commit }, data) {
  //     try {
  //         let resp = await axios.post("/center/pickup", {
  //             ...data,
  //         });

  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("UPDATE_ADDR", resp.data[0]);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },
  // async addNewAddressIncreateOrder({ commit }, data) {
  //     try {
  //         let resp = await axios.post("/center/pickup", {
  //             ...data,
  //         });

  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("INIT_ADDR_LIST", resp.data[0]);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },
  // async deleteAddress({ commit }, data) {
  //     try {
  //         let resp = await axios.delete("/center/pickup", {
  //             data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("DELETE_ADDR", data);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async editAddress({ commit }, data) {
  //     try {
  //         let resp = await axios.put("/center/pickup", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("EDIT_ADDR", resp.data[0]);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async fetchPickupConfig({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/center/pickup-config", {
  //             params: { ...data },
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("INIT_PICKUP_CONFIG_LIST", resp.data);
  //         return { status: true };
  //     } catch (error) {
  //         return { status: false, err: error };
  //     }
  // },

  // async addPickupConfig({ commit }, data) {
  //     try {
  //         let resp = await axios.post("/center/create-pickup-config", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("INIT_PICKUP_CONFIG_LIST", resp.data);
  //         return { status: true };
  //     } catch (error) {
  //         return { status: false, err: error };
  //     }
  // },

  // async editPickupConfig({ commit }, data) {
  //     try {
  //         let resp = await axios.put("/center/update-pickup-config", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("INIT_PICKUP_CONFIG_LIST", resp.data);
  //         return { status: true };
  //     } catch (error) {
  //         return { status: false, err: error };
  //     }
  // },
  // async fetchOrderPickupAddress({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/center/get-duplicate-pickup-point", {
  //             params: { ...data },
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("INIT_ADDR_ORDER_PICKUP_LIST", resp.data);
  //         return { status: true };
  //     } catch (error) {
  //         return { status: false, err: error };
  //     }
  // },

  // async editOrderPickupAddress({ commit }, data) {
  //     try {
  //         let resp = await axios.put("/center/update-pickup-flag", {
  //             ...data
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง !";
  //         commit("UPDATE_ADDR_ORDER_PICKUP_LIST", resp.data);
  //         return { status: true };
  //     } catch (error) {
  //         return { status: false, err: error };
  //     }
  // },

  async loadAddress({ commit }, data) {
    try {
      let resp = await AddressService.apiGetAddress(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async saveAddress({ commit }, data) {
    try {
      let resp = await AddressService.apiCreatesaveAddress(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async updateAddress({ commit }, data) {
    try {
      let resp = await AddressService.apiEditAddress(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async deleteAddress({ commit }, id) {
    try {
      let resp = await AddressService.apiDeleteAddress(id);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "MESSAGE");
      return { status: false, err: err };
    }
  },

  async pickupPointConfigs({ commit }, data) {
    try {
      let resp = await AddressService.apiEditpickupPointConfigs(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "MESSAGE");
      return { status: false, err: err };
    }
  },

  async getPickupPointConfigs({ commit }, data) {
    try {
      let resp = await AddressService.apiGetPickupPointConfigs();
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "MESSAGE");
      return { status: false, err: err };
    }
  }
};
